import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';

const DialogOptions = ( { title, subTitle, handlePayType }) => {
    const [open, setOpen] = React.useState(true);

    /* const handleClickOpen = () => {
        setOpen(true);
    }; */
    const handleClose = () => {
        setOpen(false);
    };
    const handleCloseCobrar = (str) => {
        handlePayType(str)
        setOpen(false);
    };
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{ title }</DialogTitle>
            <DialogContent>
            <DialogContentText id="alert-dialog-description">
                { subTitle }
            </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={handleClose} color="primary">
                Cancelar
            </Button>
            <Button onClick={() => {handleCloseCobrar('QR')} } color="primary" autoFocus>
                QR
            </Button>
            <Button onClick={() => {handleCloseCobrar('cobrar')}} color="primary" autoFocus>
                Cobrar
            </Button>
            </DialogActions>
      </Dialog>
    );
};

DialogOptions.propTypes = {
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string.isRequired,
    handlePayType: PropTypes.func.isRequired,
}

export default DialogOptions;